<template>
  <div>
    <subject :client="client"></subject>
    <hr />

    <h2 class="text-h6">Client email body</h2>
    <h3 class="h4 subtitle mb-4 text-muted">
      This text will appear between the global header and footer email text for your organisation
    </h3>

    <div class="redactor-wrapper">
      <vue-redactor v-model="content" @changeMade="setChangeMade" @enableSave="setEnableSave" />
    </div>
    <c-button-group>
      <c-button
        color="primary"
        :disabled="!enableSave || !changeMade"
        :class="{ 'is-loading': isSaving }"
        @click="save"
      >
        Save
      </c-button>
      <c-button v-if="showCancelButton" color="secondary" @click="cancelEdit">Cancel</c-button>
    </c-button-group>
  </div>
</template>

<script>
import _ from 'lodash';
import VueRedactor from '../../../components/vue-redactor';
import { buildEndpoint } from '@/libs/buildEndPoint';
import Subject from './subject';

export default {
  components: {
    Notification,
    Subject,
    VueRedactor,
  },
  props: {
    client: Object,
  },
  data() {
    return {
      error: null,
      isSaving: false,
      success: false,
      showCancelButton: false,
      enableSave: false,
      changeMade: false,
      content: null,
    };
  },
  created() {
    this.setData();
  },
  methods: {
    setData() {
      this.content = _.get(this.client, 'config.email.bodyText');
    },
    cancelEdit() {
      this.setData();
      this.resetButtonState();
    },
    resetButtonState() {
      this.showCancelButton = false;
      this.enableSave = false;
      this.changeMade = false;
    },
    setChangeMade() {
      this.showCancelButton = true;
      this.changeMade = true;
      this.enableSave = true;
    },
    setEnableSave(payload) {
      this.enableSave = payload;
    },
    disableSave() {
      this.enableSave = false;
    },
    save() {
      this.isSaving = true;
      this.error = null;

      const data = {
        id: this.client._id,
        text: this.content,
      };

      this.$http
        .post(buildEndpoint('clients/email/update-body-text'), data)
        .then((response) => {
          this.isSaving = false;
          if (response.data.success) {
            // openNotification({
            //   message: 'Email text saved',
            //   type: 'primary',
            //   duration: 3000
            // })
            _.set(this.client, 'config.email.bodyText', this.content);
            this.resetButtonState();
          } else {
            this.error = 'Error saving email content';
          }
        })
        .catch((error) => {
          this.isSaving = false;
          this.error = error;
        });
    },
  },
};
</script>

<style lang="scss" scoped="">
.redactor-wrapper {
  margin-bottom: 20px;
}
</style>
